import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { statsAPI } from '../../services/api';

// Async thunk for fetching stats
export const fetchStats = createAsyncThunk(
  'stats/fetchStats',
  async (_, { rejectWithValue }) => {
    try {
      const response = await statsAPI.getLiveStats();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'İstatistikler yüklenirken hata oluştu');
    }
  }
);

const statsSlice = createSlice({
  name: 'stats',
  initialState: {
    data: null,
    loading: false,
    error: null,
    lastUpdated: null,
  },
  reducers: {
    clearStats: (state) => {
      state.data = null;
      state.error = null;
    },
    setStats: (state, action) => {
      state.data = action.payload;
      state.lastUpdated = new Date().toISOString();
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStats.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.lastUpdated = new Date().toISOString();
        state.error = null;
      })
      .addCase(fetchStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearStats, setStats } = statsSlice.actions;

// Selectors
export const selectStats = (state) => state.stats.data;
export const selectStatsLoading = (state) => state.stats.loading;
export const selectStatsError = (state) => state.stats.error;
export const selectStatsLastUpdated = (state) => state.stats.lastUpdated;

export default statsSlice.reducer; 